import { render, staticRenderFns } from "./index.vue?vue&type=template&id=778f7e12&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=778f7e12&style=true&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f7e12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('778f7e12')) {
      api.createRecord('778f7e12', component.options)
    } else {
      api.reload('778f7e12', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=778f7e12&scoped=true&", function () {
      api.rerender('778f7e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/competition/index.vue"
export default component.exports